<mat-list
  *ngIf="usersOnPage"
  class="border-l border-opacity-25 border-project-100"
>
  <div *ngIf="usersOnPage.length !== 0">
    <div class="pb-1 ml-2 text-xs text-project-2000 text-inherit">
      <p>Also on page:</p>
    </div>
  </div>
  <div class="flex flex-1">
    <mat-list-item *ngFor="let user of usersOnPage.slice(0, 2)">
      <div
        class="flex items-center justify-center flex-1 p-2 ml-2 text-sm bg-white text-project-2000 text-inherit"
      >
        <p class="pr-1.5 font-bold">{{ user.username }}</p>
        <p
          [ngClass]="
            getUserAction(user.action) === 'editing'
              ? 'text-project-2100'
              : 'text-project-2000 brightness-75'
          "
        >
          is {{ getUserAction(user.action) }}
        </p>
        <a class="items-center text-project-1100" [href]="sanitise(user.email)">
          <mat-icon class="mt-1 text-base text-center">mail</mat-icon>
        </a>
      </div>
    </mat-list-item>
    <button
      *ngIf="usersOnPage.length > 2"
      class="flex items-center justify-center p-1.5 ml-2 text-sm font-bold bg-white text-inherit hover:bg-gray-50 text-project-2000 text-inherit"
      mat-button
      [matMenuTriggerFor]="menu"
    >
      +{{ usersOnPage.length - 2 }} more
      <mat-icon>expand_more</mat-icon>
    </button>

    <mat-menu
      #menu="matMenu"
      class="flex flex-1 bg-white border border-gray-200 rounded-lg shadow-lg text-project-2000 text-inherit"
    >
      <div mat-menu-item *ngFor="let user of usersOnPage.slice(2)">
        <div
          class="flex items-center justify-center flex-1 text-sm text-inherit"
        >
          <p class="font-bold pr-0.5">
            {{ user.username }}
          </p>

          <span class="text-project-2000 brightness-75">
            is {{ getUserAction(user.action) }}</span
          >
        </div>
      </div>
    </mat-menu>
  </div>
</mat-list>
